core.constant('baseOfCaseTranslationPL', {
  "T": {
    "UI": {
      "BASE_OF_CASE_HEADER" : {
        "BASE_OF_CASE": "Baza przypadków"
      }
    },
    "MODULE": {
      "BASE_OF_CASE" : {
        "BASE_OF_CASE": "Baza przypadków",
        "SEARCH_FOR_CASES_THAT_MEET_THE_FOLLOWING_CRITERIA": "Wyszukaj przypadki spełniające następujące kryteria",
        "DIAGNOSIS": "Rozpoznanie",
        "SELECT_COLUMNS": "Wybierz kolumny",
        "RECONNAISSANCE": "Wywiad",
        "PHYSICAL_EXAMINATION": "Badanie przedmiotowe",
        "MAIN_DIAGNOSIS": "Rozpoznanie główne",
        "DOCTOR_ORDERS": "Zalecenia lekarskie",
        "ICF_CLASSIFICATION": "Klasyfikacja ICF",
        "DRUG_LIST": "Lista leków",
        "DRUGS": "Leki",
        "DOCUMENT_LIST": "Lista dokumentów",
        "ICF_CLASSIFICATIONS": "Kwalifikacje ICF",
        "ICD9_PROCEDURE": "Procedura ICD-9",
        "INSERT_ICD10_CODE": "Wpisz kod icd10 lub nazwę rozpoznania...",
        "INSERT_ICD9_CODE": "Wpisz kod icd9 lub nazwę procedury...",
        "INSERT_ICF_CODE": "Wpisz kod icf lub nazwę kwalifikacji...",
        "INSERT_GENDER": "Wybierz płeć pacjenta...",
        "SELECTED_DIAGNOSIS": "Wybrane rozpoznania",
        "SELECTED_PROCEDURES": "Wybrane procedury",
        "SELECTED_CLASSIFICATIONS": "Wybrane klasyfikacje",
        "PATIENT_AGE_FROM": "Wiek pacjenta od",
        "PATIENT_AGE_TO": "Wiek pacjenta do",
        "CHANGE_SEARCH_CRITERIA": "Zmień kryteria wyszukiwania",
        "SEARCH": "Szukaj",
        "CLEAR": "Wyczyść",
        "VISIT_CARD": "Karta wizyty",
        "STATE_OF_HEALTH": "Stan zdrowia",
        "VISIT_HISTORY": "Historia wizyt",
        "NOTHING_FOUND": "Brak danych, spróbuj innych kryteriów",
        "VISIT_TYPE": "Typ wizyty",
        "DATE": "Data",
        "NO_DOCUMENTS": "Brak dokumentów",
        "UPLOAD_CSV_FILE": "Przesyłanie pliku CSV",
        "SELECT_FILE": "Wybierz plik",
        "PLEASE_ENCLOSE_CSV_FILE": "Załącz plik w formacie CSV",
        "FILE_HAS_BEEN_UPLOADED": "Plik został przesłany",
        "PLEASE_WAIT_WHILE_UPLOADING": "Proszę czekać, plik jest przesyłany"
      }
    },
    "ENUM": {
      "ATTACHMENT_TYPE": {
        "OTHER": "OTHER",
        "EWUS_STATEMENT_BY_AUTHORIZED_PERSON": "EWUS_STATEMENT_BY_AUTHORIZED_PERSON",
        "EWUS_STATEMENT": "EWUS_STATEMENT",
        "EPICRISIS_PDF": "EPICRISIS_PDF",
        "PRESCRIPTION_PDF": "PRESCRIPTION_PDF",
        "REFERRAL_PDF": "REFERRAL_PDF",
        "SICK_LEAVE_PDF": "SICK_LEAVE_PDF"
      }
    }
  }
});


